import { Button, Link, styled } from 'opensolar-ui'
import { useTranslate } from 'ra-core'
import { FC } from 'react'

interface ActionProps {
  dismissLabel?: string
  ctaLabel: string
  clickUrl: string
  onClose: () => void
  onClick: () => void
}

const ActionWrapper = styled('div', { name: 'ActionWrapper' })({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  marginTop: 10,
})

const StyledButton = styled(Button)({
  '&:focus': {
    boxShadow: 'none !important',
  },
})

const ToastActions: FC<ActionProps> = ({ onClose, dismissLabel, ctaLabel, clickUrl, onClick }) => {
  const translate = useTranslate()
  return (
    <ActionWrapper>
      <StyledButton onClick={onClose} variant="text" color="info">
        {dismissLabel || translate('Dismiss')}
      </StyledButton>
      <Link href={clickUrl} target="_blank" rel="noreferrer">
        <StyledButton variant="text" color="secondary" onClick={onClick}>
          {ctaLabel}
        </StyledButton>
      </Link>
    </ActionWrapper>
  )
}

export default ToastActions
